import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ShareLink } from "@/domain";
export type ConsoleShareLink = ShareLink & {
  name: string;
  access: "latest" | "history";
  recipientLabel: string;
};
interface ShareLinkState {
  created: ConsoleShareLink[];
  overrides: Record<
    string,
    Partial<Pick<ConsoleShareLink, "expiresAt" | "revokedAt">>
  >;
  add: (link: ConsoleShareLink) => void;
  update: (
    id: string,
    patch: Partial<Pick<ConsoleShareLink, "expiresAt" | "revokedAt">>,
  ) => void;
}
export const useShareLinkStore = create<ShareLinkState>()(
  persist(
    (set) => ({
      created: [],
      overrides: {},
      add: (link) => set((s) => ({ created: [link, ...s.created] })),
      update: (id, patch) =>
        set((s) => ({
          overrides: { ...s.overrides, [id]: { ...s.overrides[id], ...patch } },
        })),
    }),
    { name: "latisent-shares-v2" },
  ),
);
